<template>
  <v-container class="cmp-settings-promotion-settings dt-sidewindow submodule-root">
    <div class="dt-tabs-container submodule-root">
      <glayout
        :tabs="labelSettingsTabs"
        :loading="promotionSettingsData && promotionSettingsData.loading"
        tabPanelColor="secondary"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    promotionSettingsData &&
                      promotionSettingsData.categories &&
                      promotionSettingsData.categories.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('category')"
              >
                <DBox
                  :id="'cmp-settings-booking-travel-options'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('category')}`"
                  @add_click="onCategoryAddClick"
                >
                  <DList
                    v-if="promotionSettingsData"
                    :items="promotionSettingsData.categories"
                    :clickable="true"
                    :primaryKey="'category_id'"
                    :labelKey="'category_name'"
                    @delete="onCategoryDelete"
                    @item_click="onCategoryClick"
                  />
                </DBox>
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    promotionSettingsData &&
                      promotionSettingsData.media_types &&
                      promotionSettingsData.media_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('media_type')"
              >
                <DBox
                  :id="'cmp-settings-booking-travel-options'"
                  :addButton="false"
                  :addLink="true"
                  :addLinkLabel="`${$t('add')} ${$t('media_type')}`"
                  @add_click="onMediaTypeAddClick"
                >
                  <DList
                    v-if="promotionSettingsData"
                    :items="promotionSettingsData.media_types"
                    :clickable="true"
                    :primaryKey="'media_type_id'"
                    :labelKey="'media_type_name'"
                    @delete="onMediaTypeDelete"
                    @item_click="onMediaTypeClick"
                  />
                </DBox>
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    promotionSettingsData &&
                      promotionSettingsData.promotion_custom_fields &&
                      promotionSettingsData.promotion_custom_fields.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('promotion_custom_fields')"
              >
                <DTable
                  :linkLabelName="
                    `${$t('add')} ${$t('promotion_custom_fields_string')}`
                  "
                  :items="
                    promotionSettingsData
                      ? promotionSettingsData.promotion_custom_fields
                      : []
                  "
                  :headers="[]"
                  :itemName="$t('promotion_custom_fields')"
                  :primaryKey="'custom_field_id'"
                  :labelKey="''"
                  :fieldKey="'field_label'"
                  :fieldPlaceholder="'Custome Field Name'"
                  @add_click="onCustomFieldAddClick('promotion')"
                  @changed="onPromotionCustomFieldChange"
                  @selected="onMediaTypeSelect"
                  @deleted="onPromotionCustomFieldDelete"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    promotionSettingsData &&
                      promotionSettingsData.result_types &&
                      promotionSettingsData.result_types.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('promotion_result_types')"
              >
                <DTable
                  :linkLabelName="
                    `${$t('add')} ${$t('promotion_result_type_string')}`
                  "
                  :items="
                    promotionSettingsData
                      ? promotionSettingsData.result_types
                      : []
                  "
                  :headers="[]"
                  :itemName="$t('result_types')"
                  :primaryKey="'result_type_id'"
                  :labelKey="''"
                  :fieldKey="'result_type'"
                  :fieldPlaceholder="'Name'"
                  @add_click="onResultTypeAddClick"
                  @changed="onResultTypeChange"
                  @deleted="onResultTypeDelete"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    promotionSettingsData &&
                      promotionSettingsData.result_custom_fields &&
                      promotionSettingsData.result_custom_fields.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('result_custom_fields')"
              >
                <DTable
                  :linkLabelName="
                    `${$t('add')} ${$t('result_custom_fields_string')}`
                  "
                  :items="
                    promotionSettingsData
                      ? promotionSettingsData.result_custom_fields
                      : []
                  "
                  :headers="[]"
                  :itemName="$t('income_group')"
                  :primaryKey="'custom_field_id'"
                  :labelKey="''"
                  :fieldKey="'field_label'"
                  :fieldPlaceholder="'Name'"
                  @add_click="onCustomFieldAddClick('result')"
                  @changed="onResultCustomFieldChange"
                  @deleted="onResultCustomFieldDelete"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addCategoryForm'" :width="'small'">
      <AddCategoryForm @done="formatSubmitted" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'addMediaTypeForm'" :width="'small'">
      <AddMediaTypeForm
        @done="productTypeSubmitted"
        @cancelled="onModalCancelled"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'priceListForm'" :width="'small'">
      <PriceListForm @done="priceListSubmitted" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'mediaTypeForm'" :width="'small'">
      <MediaTypeForm @done="onMediaTypeSubmit" @cancelled="onModalCancelled" />
    </ModalContainer>
    <ModalContainer :modalKey="'priceCodeForm'" :width="'small'">
      <PriceCodeForm @done="onPriceCodeSubmit" @cancelled="onModalCancelled" />
    </ModalContainer>

    <ModalContainer :modalKey="'addLicenceStatus'" :width="'small'">
      <QuickModal
        :title="$t('add_new_licence_status')"
        :placeholder="$t('licence_status_name')"
        @cancelled="onModalCancelled"
        @ok="onNewLicenceStatusAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editLicenceStatus'" :width="'small'">
      <QuickModal
        :value="licenceStatusText"
        :title="$t('edit_licence_status')"
        :placeholder="$t('licence_status_name')"
        @cancelled="onModalCancelled"
        @ok="onLicenceStatusEdited"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addDealType'" :width="'small'">
      <QuickModal
        :title="$t('add_new_deal_type')"
        :forms="dealTypeForm"
        :formData="dealTypeFormData"
        @cancelled="onModalCancelled"
        @ok="onNewDealTypeAdded"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editDealType'" :width="'small'">
      <QuickModal
        :title="$t('edit_deal_type')"
        :forms="dealTypeForm"
        :formData="dealTypeFormData"
        @cancelled="onModalCancelled"
        @ok="onDealTypeEdited"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'addAdvanceType'" :width="'small'">
      <QuickModal
        :title="$t('add_new_advance_type')"
        :placeholder="$t('advance_type_name')"
        @cancelled="onModalCancelled"
        @ok="onNewAdvanceTypeAdd"
      />
    </ModalContainer>
    <ModalContainer :modalKey="'editAdvanceType'" :width="'small'">
      <QuickModal
        :value="advance_type_name"
        :title="$t('edit_new_advance_type')"
        :placeholder="$t('advance_type_name')"
        @cancelled="onModalCancelled"
        @ok="onAdvanceTypeEdit"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import DList from "@dtplugins/list/dlist";
import * as ActionTypes from "../../store/types";
import { mapKeyToAction, mapActionObject } from "../../../../store/global";
import { SettingsStoreNamespace as storeNS } from "../../store";
import { mapGetters } from "vuex";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import {
  createModalMixin,
  closeModalRoute,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import QuickModal from "@plugins/quickmodal/quickmodal";
import { createFields } from "../../../../plugins/quickmodal";
import ModalContainer from "@dtplugins/modal/modal-container";
import {
  createTextFieldConfig,
  EventHooks
} from "../../../../plugins/text-field";
import { JSONX, snakeCaseToWords } from "../../../../utility";
import { LoadingUI } from "@plugins/loading/loading";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import DTable from "@dtplugins/dtable/dtable";
import NTable from "@/plugins/datatable/datatable";
import Ddropzone from "@dtplugins/dbox/dropzone";
import { createNTableConfig } from "../../../../plugins/datatable";
import { labelSettingsActions } from "../../store/label/actions";
import { dHeaders, DHeaderTypes } from "../../../../dt-plugins/dtable";

import FormatForm from "./format-form";
import ProductTypeForm from "./product-type-form";
import PriceListForm from "./price-list-form";
import MediaTypeForm from "./media-type-form";
import PriceCodeForm from "./price-code-form";
import APIConfigs from "./api-configs";
import { isNegative } from "../../../../utility/fp";
import {
  createForms,
  createForm
} from "../../../../plugins/form-builder/form.model";
import { promotionSettingsActions } from "../../store/promotion/actions";
import AddCategoryForm from "./add-category-form";
import AddMediaTypeForm from "./add-media-type-form";
export default {
  components: {
    DBox,
    DList,
    DTable,
    QuickModal,
    ModalContainer,
    LoadingUI,
    NTable,
    Ddropzone,

    AddMediaTypeForm,
    AddCategoryForm,
    ProductTypeForm,
    PriceListForm,
    MediaTypeForm,
    PriceCodeForm,
    APIConfigs
  },
  mounted: function() {
    this.fetchData();
  },
  data: function() {
    return {
      textFieldConfig: createTextFieldConfig({
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      }),

      selectedTaxGroup: null
    };
    //MARK: Data Function
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("addCategoryForm"),
    createModalMixin("addMediaTypeForm"),
    createModalMixin("priceListForm"),
    createModalMixin("mediaTypeForm"),
    createModalMixin("priceCodeForm")
  ],
  computed: {
    ...mapGetters(storeNS, {
      promotionSettingsData: "promotionSettingsData"
    }),
    labelSettingsTabs: function() {
      return [
        {
          route: "overview",
          value: this.$t("tab_title_label_settings")
        }
        // {
        //   route: "additional_info",
        //   value: this.$t("additional_infos")
        // }
        // {
        //   route: "mechanicals",
        //   value: "mechanicals",
        //   vgi_id: "mechanicals"
        // }
      ];
    },

    formatsHeaders: function() {
      return dHeaders([
        {
          text: "Format",
          value: "format_name",
          type: DHeaderTypes.Text,
          selectable: true
        },
        {
          text: this.$t("album"),
          value: "album_single_merch",
          type: DHeaderTypes.Text,
          selectable: false
        },
        {
          text: this.$t("2_sides"),
          value: "two_sides_flag",
          type: DHeaderTypes.Checkbox,
          selectable: false
        },
        {
          text: this.$t("group"),
          value: "format_group",
          type: DHeaderTypes.TextField,
          selectable: false,
          placeholder: this.$t("group")
        }
      ]);
    },
    licenceStatusText: function() {
      return this.$route.query.licence_status_text || "";
    },
    dealTypeForm: function() {
      return createForms([
        createForm({
          required: true,
          name: "deal_type_name",
          showValidationIcons: true
        }),
        createForm({
          required: true,
          name: "deal_type_code",
          showValidationIcons: true
        })
      ]);
    },
    dealTypeFormData: function() {
      return {
        deal_type_id: this.$route.query.deal_type_id,
        deal_type_code: this.$route.query.deal_type_code,
        deal_type_name: this.$route.query.deal_type_name
      };
    },
    advance_type_name: function() {
      return this.$route.query.advance_type_name || "";
    },
    advance_type_id: function() {
      return this.$route.query.advance_type_id || "";
    }
  },
  methods: {
    dHeaders: dHeaders,
    ...mapActionObject(storeNS, promotionSettingsActions),
    createNTableConfig: createNTableConfig,
    fetchData: function() {
      this[ActionTypes.PromotionSettingsData.FETCH.ALL]();
    },
    tabSelectedRouting: function(tabId) {
      this.$router.push({
        name: "settings_label_tab",
        params: {
          tab: tabId
        }
      });
    },
    onModalCancelled: function() {
      closeModalRoute(this, {
        mode: undefined
      });
    },

    // Format Methods
    onFormatAddClick: function() {
      openModalRoute(this, "format_form", {
        mode: "add"
      });
    },
    formatSubmitted: async function({ mode, format }) {
      console.log(mode, format);
      if (mode === "add") {
        await this[ActionTypes.Formats.INSERT.SINGLE](format);
        this.onModalCancelled();
      } else if (mode === "edit") {
        await this[ActionTypes.Formats.SET.SINGLE](format);
        this.onModalCancelled();
      }
    },
    onFormatChange: function(payload) {
      this[ActionTypes.Formats.UPDATE.SINGLE](payload);
    },
    onFormatSelect: function(item) {
      openModalRoute(this, "format_form", {
        mode: "edit",
        format_id: item.format_id
      });
    },
    onFormatDelete: async function(item) {
      const confirmationResult = await ConfirmationService.createP({
        subject: "Are you sure you want to delete the Format?"
      });
      if (confirmationResult == "OK") {
        this[ActionTypes.Formats.DELETE.SINGLE](item);
      }
    },
    //Media Type
    onMediaTypeAddClick: function() {
      openModalRoute(this, "add_media_type_form", {
        mode: "add"
      });
    },
    onMediaTypeDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Media Type",
        item.field_label
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.MediaType.DELETE.SINGLE](item);
      }
    },
    onMediaTypeClick: function(item) {
      console.log("RRRRR", item);
      openModalRoute(this, "add_media_type_form", {
        mode: "edit",
        catId: item.media_type_id,
        catValue: item.media_type_name
      });
    },
    //Category Type Methods
    onCategoryAddClick: function() {
      openModalRoute(this, "add_category_form", {
        mode: "add"
      });
    },
    onCategoryClick: function(item) {
      console.log(item.category_id);
      openModalRoute(this, "add_category_form", {
        mode: "edit",
        catId: item.category_id,
        catValue: item.category_name
      });
    },
    onCategoryDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Category",
        item.category_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.Category.DELETE.SINGLE](item);
      }
    },
    productTypeSubmitted: async function({ mode, product_type }) {
      if (mode === "add") {
        await this[ActionTypes.ProductTypes.INSERT.SINGLE](product_type);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.ProductTypes.UPDATE.SINGLE](product_type);
        this.onModalCancelled();
      }
    },
    onProductTypeDelete: async function(item) {
      const confirmationResult = await ConfirmationService.createP({
        subject: "Are you sure you want to delete the Product Type?"
      });
      if (confirmationResult == "OK") {
        this[ActionTypes.ProductTypes.DELETE.SINGLE](item);
      }
    },
    onProductTypeClick: function(item) {
      openModalRoute(this, "product_type_form", {
        mode: "edit",
        product_type_id: item.product_type_id
      });
    },

    //Price List Methods
    onPriceListAddClick: function() {
      openModalRoute(this, "price_list_form", {
        mode: "add"
      });
    },
    priceListSubmitted: async function({ mode, price_list }) {
      console.log({ mode, price_list });
      if (mode === "add") {
        await this[ActionTypes.PriceLists.INSERT.SINGLE](price_list);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.PriceLists.UPDATE.SINGLE](price_list);
        this.onModalCancelled();
      }
    },
    onPriceListChange: function() {},
    onPriceListSelect: function(item) {
      console.log(item);
      openModalRoute(this, "price_list_form", {
        mode: "edit",
        price_list_id: item.price_list_id
      });
    },
    onPriceListDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Price List",
        item.price_list_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.PriceLists.DELETE.SINGLE](item);
      }
    },

    //Media type Methods
    onCustomFieldAddClick: function(ext_table) {
      this[ActionTypes.CustomFileds.INSERT.SINGLE](ext_table);
    },
    onResultCustomFieldChange: function({ name, value, item }) {
      let payload = { data: { name, value, item }, ext_table: "p_results" };
      this[ActionTypes.CustomFileds.UPDATE.SINGLE](payload);
    },
    onPromotionCustomFieldChange: function({ name, value, item }) {
      let payload = { data: { name, value, item }, ext_table: "promotion" };
      this[ActionTypes.CustomFileds.UPDATE.SINGLE](payload);
    },
    onPromotionCustomFieldDelete: async function(item) {
      let payload = { data: item, ext_table: "promotion" };
      if (!isNegative(item.custom_field_id)) {
        const confirmationResult = await confirmDelete(
          "Promtion Custom Field",
          item.field_label
        );
        if (confirmationResult == "OK") {
          this[ActionTypes.CustomFileds.DELETE.SINGLE](payload);
        }
      } else {
        this[ActionTypes.CustomFileds.DELETE.SINGLE](payload);
      }
    },
    onResultCustomFieldDelete: async function(item) {
      let payload = { data: item, ext_table: "p_results" };
      if (!isNegative(item.custom_field_id)) {
        const confirmationResult = await confirmDelete(
          "Result Custom Field",
          item.field_label
        );
        if (confirmationResult == "OK") {
          this[ActionTypes.CustomFileds.DELETE.SINGLE](payload);
        }
      } else {
        this[ActionTypes.CustomFileds.DELETE.SINGLE](payload);
      }
    },
    onMediaTypeSubmit: async function({ mode, media }) {
      if (mode == "add") {
        await this[ActionTypes.MediaTypes.INSERT.SINGLE](media);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.MediaTypes.UPDATE.SINGLE](media);
        this.onModalCancelled();
      }
    },
    onMediaTypeSelect: function(item) {
      console.log(item.media_id);
      openModalRoute(this, "media_type_form", {
        mode: "edit",
        media_id: item.media_id
      });
    },
    // onMediaTypeDelete: async function(item) {
    //   const confirmationResult = await confirmDelete("Media Type", item.mechanical_name);
    //   if (confirmationResult == "OK") {
    //     this[ActionTypes.MediaTypes.DELETE.SINGLE](item);
    //   }
    // },

    //Price Code Methods
    onPriceCodeAddClick: function() {
      openModalRoute(this, "price_code_form", {
        mode: "add"
      });
    },
    onPriceCodeSubmit: async function({ mode, price_code }) {
      console.log({ mode, price_code });
      if (mode == "add") {
        await this[ActionTypes.PriceCodes.INSERT.SINGLE](price_code);
        this.onModalCancelled();
      } else if (mode == "edit") {
        await this[ActionTypes.PriceCodes.UPDATE.SINGLE](price_code);
        this.onModalCancelled();
      }
    },
    onPriceCodeSelect: function(item) {
      openModalRoute(this, "price_code_form", {
        mode: "edit",
        price_code_id: item.price_code_id
      });
    },
    onPriceCodeDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Price Code",
        item.price_code_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.PriceCodes.DELETE.SINGLE](item);
      }
    },

    // Licence Status Methods
    onAddLicenceAccount: function() {
      openModalRoute(this, "add_licence_status");
    },
    onNewLicenceStatusAdded: function(value) {
      if (value) {
        this[ActionTypes.LicenceStatus.INSERT.SINGLE]({
          licence_status_text: value
        });
      }
      this.onModalCancelled();
    },
    onLicenceStatusEdited: function(value) {
      this[ActionTypes.LicenceStatus.UPDATE.SINGLE]({
        licence_status_text: value,
        licence_status_id: this.$route.query.licence_status_id
      });
      this.onModalCancelled();
    },
    onLicenceStatusDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Licence",
        item.licence_status_text
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.LicenceStatus.DELETE.SINGLE](item);
      }
    },
    onLicenceStatusClick: function(item) {
      const { licence_status_text, licence_status_id } = item;
      openModalRoute(this, "edit_licence_status", {
        licence_status_text,
        licence_status_id
      });
    },
    // Marketting Type Methods
    onResultTypeAddClick: function() {
      this[ActionTypes.ResultTypes.INSERT.SINGLE]();
    },
    onResultTypeChange: function({ name, value, item }) {
      this[ActionTypes.ResultTypes.UPDATE.SINGLE]({ name, value, item });
    },

    onResultTypeDelete: async function(item) {
      if (!isNegative(item.marketing_type_id)) {
        const confirmationResult = await confirmDelete(
          "Marketing Type",
          item.marketing_type_name
        );
        if (confirmationResult == "OK") {
          this[ActionTypes.ResultTypes.DELETE.SINGLE]({ item });
        }
      } else {
        this[ActionTypes.ResultTypes.DELETE.SINGLE]({ item });
      }
    },

    onModalCancelled: function() {
      closeModalRoute(this, {
        mode: undefined,
        format_id: undefined,
        product_type_id: undefined,
        price_list_id: undefined,
        media_id: undefined,
        price_code_id: undefined,
        licence_status_id: undefined,
        licence_status_text: undefined,
        deal_type_id: undefined,
        deal_type_name: undefined,
        deal_type_code: undefined,
        advance_type_name: undefined,
        advance_type_id: undefined
      });
    },

    // API Config Methods
    onAPIConfigChange: function(payload) {
      this[ActionTypes.APIConfig.UPDATE.ALL](payload);
    },
    onAPIConfigAddClick: function() {
      openModalRoute(this, "add_config");
    },
    onAPIAdd: function(payload) {
      this[ActionTypes.APIConfig.INSERT.SINGLE](payload);
      this.onModalCancelled();
    },
    onAPIDeleted: async function(payload) {
      const { form_name, item } = payload;

      const key = this.promotionSettingsData.translator_api_configs_structure[
        form_name
      ][0].name;
      const value = item[key];
      console.log(item);

      const confirmationResult = await confirmDelete(
        "API Config",
        ` ${form_name} ${snakeCaseToWords(key)} : ${value}`
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.APIConfig.DELETE.SINGLE](payload);
      }
    },

    // Deal Type Methods
    onDealTypeAddClick: function() {
      openModalRoute(this, "add_deal_type");
    },
    onDealTypeChange: function() {},
    onDealTypeSelected: function(item) {
      const { deal_type_id, deal_type_name, deal_type_code } = item;
      openModalRoute(this, "edit_deal_type", {
        deal_type_id,
        deal_type_name,
        deal_type_code
      });
    },
    onDealTypeDeleted: async function(item) {
      const confirmationResult = await confirmDelete(
        "Deal Type",
        item.deal_type_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.DealTypes.DELETE.SINGLE](item);
      }
    },
    onNewDealTypeAdded: function(payload) {
      this[ActionTypes.DealTypes.INSERT.SINGLE](payload);
      this.onModalCancelled();
    },
    onDealTypeEdited: function(payload) {
      this[ActionTypes.DealTypes.UPDATE.SINGLE](payload);
      this.onModalCancelled();
    },
    onAdvanceTypeAddClick: function() {
      openModalRoute(this, "add_advance_type");
    },
    onAdvanceTypeClick: function({ advance_type_id, advance_type_name }) {
      openModalRoute(this, "edit_advance_type", {
        advance_type_id,
        advance_type_name
      });
    },
    onAdvanceTypeDelete: async function(item) {
      const confirmationResult = await confirmDelete(
        "Advance Type",
        item.advance_type_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.AdvanceType.DELETE.SINGLE](item);
      }
    },
    onNewAdvanceTypeAdd: function(value) {
      if (value) {
        this[ActionTypes.AdvanceType.INSERT.SINGLE]({
          advance_type_name: value
        });
      }
      this.onModalCancelled();
    },
    onAdvanceTypeEdit: function(value) {
      this[ActionTypes.AdvanceType.UPDATE.SINGLE]({
        advance_type_name: value,
        advance_type_id: this.advance_type_id
      });
      this.onModalCancelled();
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-promotion-settings {
  .dt-grid-layout {
    height: calc(100vh - 124px);
  }

  .invoice-notifications {
    .dt-checkbox-control {
      padding-top: 10px;
      padding-left: 3px;
      .dt-checkbox {
        max-width: 40px;
        margin-right: 10px;
        margin-top: 5px;
      }
      .dt-checkbox-label {
        flex: 1;
      }
    }
  }
}
</style>
